export default __webpack_public_path__ + "static/media/goopter-free-consumer-mobile-app.bf209867.png";